import React from "react";

export default function AdminTable({ children, mobileCards }) {
  return (
    <>
      {mobileCards ? <div className="md:hidden space-y-3">{mobileCards}</div> : null}
      <div
        className={`rounded-lg border border-slate-200 bg-white overflow-x-auto ${
          mobileCards ? "hidden md:block" : ""
        }`}
      >
        {children}
      </div>
    </>
  );
}

export function AdminMobileCard({ title, subtitle, badge, meta = [], actions, onClick, leading }) {
  return (
    <article
      className={`rounded-lg border border-slate-200 bg-white p-4 ${
        onClick ? "cursor-pointer hover:border-slate-300 hover:bg-slate-50/80" : ""
      }`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          {leading}
          <div className="min-w-0">
            <p className="font-medium text-slate-900 truncate">{title}</p>
            {subtitle ? <p className="text-sm text-slate-500 mt-0.5 truncate">{subtitle}</p> : null}
          </div>
        </div>
        {badge}
      </div>
      {meta.length > 0 ? (
        <dl className="mt-3 grid grid-cols-2 gap-x-3 gap-y-2 text-sm">
          {meta.map(({ label, value }) => (
            <div key={label} className="min-w-0">
              <dt className="text-[11px] uppercase tracking-[0.06em] text-slate-400">{label}</dt>
              <dd className="text-slate-700 truncate">{value || "—"}</dd>
            </div>
          ))}
        </dl>
      ) : null}
      {actions ? (
        <div className="mt-3 flex flex-wrap gap-2" onClick={(e) => e.stopPropagation()}>
          {actions}
        </div>
      ) : null}
    </article>
  );
}

export const adminTableHeadClass =
  "text-[11px] uppercase tracking-[0.08em] text-slate-500 font-medium h-10";
export const adminTableRowClass =
  "border-slate-100 hover:bg-slate-50 transition-colors";
export const adminClickableRowClass = `${adminTableRowClass} cursor-pointer`;
